import { render, staticRenderFns } from "./SidLoader.vue?vue&type=template&id=7cf22e7b&scoped=true"
import script from "./SidLoader.vue?vue&type=script&lang=js"
export * from "./SidLoader.vue?vue&type=script&lang=js"
import style0 from "./SidLoader.vue?vue&type=style&index=0&id=7cf22e7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf22e7b",
  null
  
)

export default component.exports